import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import login from "../images/login.png";
import "../styles/hero.css";
import "../styles/auth.css";
import { server } from "../server";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("Email is required");
      return false;
    }
    if (!validateEmail(email)) {
      toast.error("Invalid Email Format");
      return false;
    }
    try {
      const toastId = toast.loading("Loging In...");
      const res = await axios.post(`${server}/api/user/login`, {
        email,
        password,
      });
      if (res.data.success) {
        toast.dismiss(toastId);
        toast.success(res.data.message);
        setAuth({
          ...auth,
          user: res.data.user,
          token: res.data.token,
        });
        localStorage.setItem("auth", JSON.stringify(res.data));
        navigate(location.state || "/");
      } else {
        toast.dismiss(toastId);
        toast.error(res.data.message);
      }
      toast.dismiss(toastId);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="marginStyle">
        <div class="container d-flex justify-content-center align-items-center">
          <div
            class="row border p-3 bg-white box-area reverseCol"
            style={{ borderRadius: "5px" }}
          >
            <div class="col-md-6 rounded-4 d-flex justify-content-center align-items-center flex-column left-box">
              <div class="featured-image mb-3 animateImg">
                <img src={login} class="img-fluid" alt="login-i" width={500} />
              </div>
            </div>
            <form class="col-md-6 right-box">
              <div class="row align-items-center">
                <div class="header-text mb-4">
                  <h2>Welcome</h2>
                  <p>We are happy to have you back !</p>
                </div>
                <div class="input-group d-flex  align-items-center mb-3">
                  <div class="form-outline flex-fill mb-0">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      type="email"
                      placeholder="Your email ID"
                      class="form-control"
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div class="input-group d-flex flex-row align-items-center mb-3">
                  <div class="form-outline flex-fill mb-0">
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      type="password"
                      placeholder="Your password"
                      class="form-control"
                      style={{ borderRadius: "5px" }}
                    />
                  </div>
                </div>
                <div class="d-flex flex-row align-items-center mt-4 ">
                  <div class="form-outline flex-fill mb-0">
                    <button
                      class="btn btn-lg  text-white"
                      type="button"
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: "blueviolet",
                        width: "100%",
                        borderRadius: "5px",
                      }}
                    >
                      Login
                    </button>
                  </div>
                </div>
                <div class="d-flex flex-row align-items-center my-3 ">
                  <div class="form-outline flex-fill mb-0 ">
                    <Link
                      to="/register"
                      class="btn btn-outline-dark btn-lg btn-block"
                      style={{ width: "100%", borderRadius: "5px" }}
                      type="button"
                    >
                      Register
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
